export default __webpack_public_path__ + "media/icons/live-icon-268d24a9.svg";